<template>
  <div class="full-image" v-if="fullscreen">
      <v-btn fab icon @click="closeFull"><v-icon>mdi-close</v-icon></v-btn>
      <v-card>
        <v-img :src="imageSrc(fullImage)" contain height="100vh"></v-img>
      </v-card>
    </div>
</template>

<script>
export default {
  data: () => ({
    fullscreen: false,
    fullImage: ''
  }),
  methods: {
    enlarge(img) {
      this.fullscreen = true;
      this.fullImage = img;
    },
    closeFull() {
      this.fullscreen =  false;
    },
    imageSrc(chartName) {
      //console.log(chartName)
      if (chartName.includes("https://api.mi-sos.org/uploads")) {
        return chartName
      }
      return "https://api.mi-sos.org/uploads/" + chartName;
    }
  }
}
</script>

<style>
.full-image {
    position:fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left:0;
    background-color: rgba(230, 229, 191, 0.87);
  }
</style>